import Vue from 'www/vue_components'
import { pinia } from 'www/plugins'
import SynonymListManage from 'www/vue_components/common/SynonymListManage/SynonymListManage.vue'
import { NAMESPACE } from 'www/modules/Schedule/classes/ScheduleServices/constants'

/**
 * @description
 * Производит рендер компонента списка синонимов.
 *
 * @param {object} opts -
 * @param {object} opts.data - собранные данные со страницы - интерфейс 'getModuleDataInterface'
 */

const components = []

const renderSynonyms = ({ data }) => {
  const {
    dtypeId,
    dclassId,
    dcategoryId,
    dclassTranslit,
  } = data.storage

  components.forEach(instance => instance.$destroy())
  components.length = 0

  data.items.forEach(itemData => {
    const {
      lpuId,
      coverNode,
      synonymPreview,
      isEnabledLpuClub,
    } = itemData

    const props = {
      lpuId,
      dtypeId,
      dclassId,
      dcategoryId,
      dclassTranslit,
      synonymPreview,
      isEnabledLpuClub,
    }

    props.townTranslit = synonymPreview.serviceData?.townTranslit

    const mountId = `synonym-container-${lpuId}`
    const selectNode = coverNode.querySelector(NAMESPACE.synonymListMountNode) // ToDo schedule-important избавиться от привязки к DOM дереву

    selectNode.insertAdjacentHTML('afterbegin', `<div id="${mountId}"></div>`)

    const el = selectNode.querySelector(`#${mountId}`)
    const instance = new Vue({
      el,
      pinia,
      name: 'SynonymListManageRoot',
      render: h => h(SynonymListManage, { props }),
    })

    components.push(instance)
  })
}

export default renderSynonyms
